import axios, { AxiosPromise, Canceler, CancelTokenStatic } from 'axios';
import { IDevice } from '../../../@types/model/masterData/device/device';
import { IDeviceUpsert } from '../../../@types/model/masterData/device/deviceUpsert';

export default class DeviceHttpService {
    private static readonly CancelToken : CancelTokenStatic = axios.CancelToken;
    /**
     * Allows you to cancel list request
     */
    public static cancelGetList ?: Canceler;

    public static getList(divisionIds : Array<number>) : AxiosPromise<Array<IDevice>> {
        if (this.cancelGetList) {
            this.cancelGetList('GET Canceled');
            this.cancelGetList = undefined;
        }

        return axios.get(`${API_URL}/v1/MasterData/Device/GetList`, {
            params: {
                divisionIds
            },
            paramsSerializer: {
                indexes: null
            },
            cancelToken: new this.CancelToken((c) => {
                this.cancelGetList = c;
            }),
        });
    }

    public static upsert = (upsert : IDeviceUpsert, type : 'Add' | 'Edit') : AxiosPromise<IDevice> => {
        return axios.post(`${API_URL}/v1/MasterData/Device/${type}`, upsert);
    }

    public static delete = (id : number) : AxiosPromise<IDevice> => {
        return axios.delete(`${API_URL}/v1/MasterData/Device/Delete`, {
            params: { id },
        });
    }
}